import { render, staticRenderFns } from "./SiteList.vue?vue&type=template&id=0c6f36c5&scoped=true"
import script from "./SiteList.vue?vue&type=script&lang=js"
export * from "./SiteList.vue?vue&type=script&lang=js"
import style0 from "./SiteList.vue?vue&type=style&index=0&id=0c6f36c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6f36c5",
  null
  
)

export default component.exports